import { z } from 'zod';

export const signUpPageOneValidation = z.object({
	firstname: z
		.string({ required_error: 'First name is required' })
		.min(1, { message: 'First name is required' })
		.max(64, { message: 'First must be less than 64 characters' })
		.trim(),
	lastname: z
		.string({ required_error: 'Last name is required' })
		.min(1, { message: 'Last name is required' })
		.max(64, { message: 'Last must be less than 64 characters' })
		.trim(),
	mobileNumber: z
		.string({ required_error: 'Mobile Number is required' })
		.regex(new RegExp('^(09|\\+639)\\d{9}$'), { message: 'Invalid phone number' }),
	position: z
		.string({ required_error: 'First name is required' })
		.min(1, { message: 'Position is required' }),
	password: z
		.string({ required_error: 'Password is required' })
		.min(8, { message: 'Password must be at least 8 characters' })
		.max(32, { message: 'Password must be less than 32 characters' })
		.trim(),
	email: z
		.string({ required_error: 'Email is required' })
		.min(1, { message: 'Email is required' })
		.max(64, { message: 'Email must be less than 64 characters' })
		.email({ message: 'Email must be a valid email address' })
});

export const finalSignupValidation = z.object({
	firstname: z
		.string({ required_error: 'First name is required' })
		.min(1, { message: 'First name is required' })
		.max(64, { message: 'First must be less than 64 characters' })
		.trim(),
	lastname: z
		.string({ required_error: 'Last name is required' })
		.min(1, { message: 'Last name is required' })
		.max(64, { message: 'Last must be less than 64 characters' })
		.trim(),
	mobileNumber: z
		.string({ required_error: 'Mobile Number is required' })
		.regex(new RegExp('^(09|\\+639)\\d{9}$'), { message: 'Invalid phone number' }),
	position: z
		.string({ required_error: 'First name is required' })
		.min(1, { message: 'Position is required' }),
	password: z
		.string({ required_error: 'Password is required' })
		.min(8, { message: 'Password must be at least 8 characters' })
		.max(32, { message: 'Password must be less than 32 characters' })
		.trim(),
	email: z
		.string({ required_error: 'Email is required' })
		.min(1, { message: 'Email is required' })
		.max(64, { message: 'Email must be less than 64 characters' })
		.email({ message: 'Email must be a valid email address' }),
	username: z
		.string({ required_error: 'Username is required' })
		.min(6, { message: 'Username must be at least 6 characters' })
		.max(20, { message: 'Username must be less than 20 characters' })
		.regex(new RegExp('^(?![0-9]*$)[a-zA-Z0-9]+$'), {
			message: 'Domain name can only contain letters and numbers.'
		}),
	displayEmail: z
		.string()
		// .min(1, { message: 'Email is required' })
		// .max(64, { message: 'Email must be less than 64 characters' })
		.email({ message: 'Email must be a valid email address' })
		.optional()
		.or(z.literal(''))
});

export const gmailSignUpValidation = z.object({
	firstname: z
		.string({ required_error: 'First name is required' })
		.min(1, { message: 'First name is required' })
		.max(64, { message: 'First must be less than 64 characters' })
		.trim(),
	lastname: z
		.string({ required_error: 'Last name is required' })
		.min(1, { message: 'Last name is required' })
		.max(64, { message: 'Last must be less than 64 characters' })
		.trim(),
	mobileNumber: z
		.string({ required_error: 'Mobile Number is required' })
		.regex(new RegExp('^(09|\\+639)\\d{9}$'), { message: 'Invalid phone number' }),
	position: z
		.string({ required_error: 'First name is required' })
		.min(1, { message: 'Position is required' }),
	email: z
		.string({ required_error: 'Email is required' })
		.min(1, { message: 'Email is required' })
		.max(64, { message: 'Email must be less than 64 characters' })
		.email({ message: 'Email must be a valid email address' }),
	username: z
		.string({ required_error: 'Username is required' })
		.min(6, { message: 'Username must be at least 6 characters' })
		.max(20, { message: 'Username must be less than 20 characters' })
		.regex(new RegExp('^(?![0-9]*$)[a-zA-Z0-9]+$'), {
			message: 'Domain name can only contain letters and numbers.'
		}),
	displayEmail: z
		.string()
		// .min(1, { message: 'Email is required' })
		// .max(64, { message: 'Email must be less than 64 characters' })
		.email({ message: 'Email must be a valid email address' })
		.optional()
		.or(z.literal(''))
});
